import { render, staticRenderFns } from "./formattedDocumentType.vue?vue&type=template&id=07413051"
import script from "./formattedDocumentType.vue?vue&type=script&lang=js"
export * from "./formattedDocumentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports